"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.profession.list': 'Profesiones',
    'route.profession.create': 'Agregar Profesión',
    'route.profession.edit': 'Editar Profesión',
};
